import axios from 'axios'
import router from '@/router'

export default (permissions) => {
  const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
  let users = []

  axios.get(`${process.env.VUE_APP_API_BASE_URL}User`, config).then(r => {
    users = r.data

    const currentUser = users.filter(user => user.name === localStorage.getItem('username') && user.email === localStorage.getItem('email'))[0]

    permissions.map(async permission => {
      if (!currentUser.permission[permission]) {
        return await router.push({ name: 'Unauthorized' })
      }
    })
  })
}
